import type { ReactNode } from 'react';
import { CheckIcon } from '@src/components/icons/CheckIcon';
import { CloseIcon } from '@src/components/icons/CloseIcon';

export function HelpDeskActiveStatus({ active, children }: { active: boolean; children: ReactNode }) {
  return <span className={`help-desk__user-active${active ? '' : ' help-desk__user-active--deleted'}`}>
    <span className="help-desk__user-active-icon" aria-hidden="true">{active ? <CheckIcon /> : <CloseIcon />}</span>
    {children}
  </span>;
}
